import React from 'react';
import { EyeIcon, ClockIcon, BadgeCheck } from 'lucide-react';
const HeaderGlpAdv6 = () => {
  return <header className="bg-white" style={{
    fontFamily: 'Georgia, Cambria, "Times New Roman", serif'
  }} data-id="element-17699" data-mp="v2jj8tllujeo">
      {/* Top black bar */}
      <div className="bg-black h-3 w-full" data-id="element-17700" data-mp="geq41a0fliwm"></div>

      {/* Masthead section */}
      <div className="border-b border-gray-800 px-4 sm:px-6 py-4 sm:py-6" data-id="element-17701" data-mp="ld033vpa13ni">
        <div className="text-center pb-3 sm:pb-4 mb-3 sm:mb-4" data-id="element-17702" data-mp="191b0govrkl71">
          <h2 className="font-serif text-2xl sm:text-3xl font-bold tracking-tight text-gray-900" data-id="element-17703" data-mp="18zzuqjird3da">
            TRADITIONAL MEDPUB
          </h2>
          <div className="text-xs uppercase tracking-widest text-gray-500 mt-2 font-medium" data-id="element-17704" data-mp="101wbjtv8wion">
            INDEPENDENT HEALTH INVESTIGATIONS SINCE 1982
          </div>
        </div>

        <div className="flex flex-col sm:grid sm:grid-cols-3 text-xs text-gray-600 border-b border-gray-300 pb-2 gap-1 sm:gap-0" data-id="element-17705" data-mp="3krlou2gavwf8">
          <div className="text-left" data-id="element-17706" data-mp="3otqdsnvt04vj">VOL. 128, NO. 43</div>
          <div className="text-left sm:text-center" data-id="element-17707" data-mp="systlvhmbpv9">
            {(() => {
            const yesterday = new Date();
            yesterday.setDate(yesterday.getDate() - 1);
            return yesterday.toLocaleDateString('en-US', {
              weekday: 'long',
              month: 'long',
              day: 'numeric',
              year: 'numeric'
            }).toUpperCase();
          })()}
          </div>
          <div className="text-left sm:text-right" data-id="element-17708" data-mp="1bxdev6wtw10z">
            HEALTH & WELLNESS SECTION
          </div>
        </div>
      </div>

      {/* Article header */}
      <div className="px-4 sm:px-6 py-6 border-b border-gray-200" data-id="element-17709" data-mp="16wprqwbq04c1">
        <div className="max-w-4xl mx-auto" data-id="element-17710" data-mp="1lmexz5yo6yj6">
          <div className="uppercase text-xs tracking-wider text-gray-500 font-medium border-b border-gray-200 pb-2 mb-4" data-id="element-17711" data-mp="1gon446egt2cc">
            SPECIAL REPORT
          </div>

          <h1 className="font-serif text-2xl sm:text-4xl font-bold text-gray-900 leading-tight mb-6" data-id="element-17712" data-mp="1uoxznmqpz53u">
            Dr. Hogan: The Hidden Syndrome Affecting Up To 3 Million GLP-1
            Users... Maybe Even You
          </h1>

          {/* Author Byline */}
          <div className="flex items-center gap-4 mb-6 pb-5 border-b border-gray-200" data-id="element-17713" data-mp="sa73ew90ob23">
            <div className="w-16 h-16 rounded-full overflow-hidden flex-shrink-0 bg-gray-200" data-id="element-17714" data-mp="wc22rv7e0ed8">
              <img src="https://cdn.magicpatterns.com/uploads/5VxcxuZ348arn9hf8oRkeE/6OUBdNn4rvjDcxkk8ToP9_(1).jpg" alt="Dr. Robin Hogan" className="w-full h-full object-cover" data-id="element-17715" data-mp="11321n602h6id" />
            </div>
            <div className="flex-1" data-id="element-17716" data-mp="1b1817gyei0k2">
              <div className="flex items-center gap-2 mb-2" data-id="element-17717" data-mp="1b06nf4q02zyn">
                <span className="text-base font-medium text-gray-900" data-id="element-17718" data-mp="1g0uf7sm1zktx">
                  Written By Robin Hogan, RN, MSN
                </span>
                <BadgeCheck className="h-5 w-5 text-blue-600" data-id="element-17719" data-mp="1k1mmigbd7fnk" />
              </div>
              <div className="text-sm text-gray-600 mb-2" data-id="element-17720" data-mp="3hszbthehz6az">
                Verified Metabolic Health Specialist
              </div>
              <div className="flex items-center gap-4 text-sm text-gray-500" data-id="element-17721" data-mp="3ltsxs58dqb18">
                <div className="flex items-center gap-1" data-id="element-17722" data-mp="3eas1o4zwrjnw">
                  <ClockIcon className="h-4 w-4" data-id="element-17723" data-mp="39jjrv7uo1wa7" />
                  <span data-id="element-17724" data-mp="39hz01pzqkrg1">4 min read</span>
                </div>
                <div className="flex items-center gap-1" data-id="element-17725" data-mp="34jfdpoh8ddn5">
                  <EyeIcon className="h-4 w-4" data-id="element-17726" data-mp="34huh7tbcvkmn" />
                  <span data-id="element-17727" data-mp="30jn1n1smopd1">171,892 views</span>
                </div>
              </div>
            </div>
          </div>

          <div className="mb-6" data-id="element-17728" data-mp="12ygxlih4t4g"></div>

          <p className="text-lg font-medium text-gray-700 mb-6 leading-relaxed border-l-4 border-gray-800 pl-4" data-id="element-17729" data-mp="3s9rttmmmqgot">
            The Dopamine Problem Researchers Just Discovered In GLP-1 Users—And
            The Breakthrough Protocol That's Bringing Back Joy Without Stopping
            The Weight Loss
          </p>

          <div className="border-t border-gray-200 pt-3 mb-6 text-xs text-gray-500 flex flex-wrap justify-between" data-id="element-17730" data-mp="2csr9u4o69u5s">
            <div className="mb-1 flex items-center" data-id="element-17731" data-mp="27toghhhk1cdn">
              <span className="font-medium mr-2" data-id="element-17732" data-mp="27wap7kg6lxxg">Published by:</span>
              Traditional Medicine Publications
            </div>
            <div className="mb-1 flex items-center" data-id="element-17733" data-mp="4chzovoa39n1">
              <span className="font-medium mr-2" data-id="element-17734" data-mp="4e1e0gqdjam6">Published:</span>
              January 2026
            </div>
          </div>
        </div>
      </div>
    </header>;
};
export default HeaderGlpAdv6;